import React from 'react';

const QuorumStatus = ({ 
  quorumStatus, 
  onClick, 
  size = 'normal',
  showDetails = false,
  className = ''
}) => {
  if (!quorumStatus) return null;

  const sizeClasses = {
    small: 'px-1.5 py-0.5 text-xs',
    normal: 'px-2 py-1 text-xs',
    large: 'px-3 py-2 text-sm'
  };

  const baseClasses = `rounded-full font-medium hover:opacity-80 ${sizeClasses[size]} ${className}`;
  
  const statusClasses = quorumStatus.present
    ? 'bg-emerald-50 text-emerald-900 border-emerald-200/80'
    : 'bg-rose-50 text-rose-900 border-rose-200/80';

  const handleClick = onClick ? onClick : undefined;
  const Component = onClick ? 'button' : 'div';

  return (
    <Component
      onClick={handleClick}
      className={`${baseClasses} ${statusClasses} ${onClick ? 'cursor-pointer' : 'cursor-default'}`}
      title={onClick ? "Click to adjust attendance" : quorumStatus.details}
    >
      {showDetails ? (
        <>
          {quorumStatus.present ? '✓ Present' : '⚠ Not Present'} ({quorumStatus.details})
        </>
      ) : (
        quorumStatus.text
      )}
    </Component>
  );
};

export default QuorumStatus;